export type OauthType =
  | 'ga'
  | 'bitly'
  | 'facebook'
  | 'salesforce'
  | 'box'
  | 'amazon-ads'
  | 'snapchat'
  | 'pinterest'
  | 'facebook-marketing'
export type OauthWithFields = 'google-ads' | 'snapchat'

export function isOauthType(slug: string): slug is OauthType {
  return [
    'ga',
    'bitly',
    'facebook',
    'salesforce',
    'box',
    'amazon-ads',
    'pinterest',
    'facebook-marketing',
  ].includes(slug)
}

export function isOauthWithFieldsType(slug: string): slug is OauthType {
  return ['google-ads', 'snapchat', 'tiktok'].includes(slug)
}
